import {
  Alert,
  Anchor,
  Card,
  Code,
  Group,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconChartDots3, IconInfoCircle } from "@tabler/icons-react";
import { Link, useParams } from "@tanstack/react-router";

import { useGrafanaDashboards, withKiosk } from "../lib/grafanaDashboards";

export function GrafanaPage() {
  const { dashboardId } = useParams({ from: "/grafana/$dashboardId" });
  const [dashboards] = useGrafanaDashboards();
  const dashboard = dashboards.find((d) => d.id === dashboardId);

  if (!dashboard) {
    return (
      <Stack gap="md">
        <Group gap="xs" align="center">
          <IconChartDots3 size={20} />
          <Title order={3}>Grafana</Title>
        </Group>
        <Alert icon={<IconInfoCircle size={16} />} color="yellow" variant="light" title="Dashboard not found">
          <Text size="sm">
            The requested dashboard is no longer configured. Manage dashboards under{" "}
            <Anchor component={Link} to="/settings">Settings</Anchor>.
          </Text>
        </Alert>
      </Stack>
    );
  }

  const src = withKiosk(dashboard.url);

  return (
    <Stack gap="md">
      <Group gap="xs" align="center">
        <IconChartDots3 size={20} />
        <Title order={3}>{dashboard.title}</Title>
      </Group>

      {src ? (
        <Card withBorder padding={0} style={{ overflow: "hidden" }}>
          <iframe
            title={dashboard.title}
            src={src}
            style={{
              width: "100%",
              height: "calc(100vh - 160px)",
              minHeight: 600,
              border: 0,
              display: "block",
            }}
            allow="fullscreen"
          />
        </Card>
      ) : (
        <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light" title="No Grafana URL configured">
          <Stack gap={4}>
            <Text size="sm">
              This dashboard entry has no URL. Update it under{" "}
              <Anchor component={Link} to="/settings">Settings</Anchor>.
            </Text>
            <Text size="xs" c="dimmed">
              Tip: Grafana blocks iframe embedding by default. Set{" "}
              <Code>allow_embedding = true</Code> in <Code>grafana.ini</Code> (or{" "}
              <Code>GF_SECURITY_ALLOW_EMBEDDING=true</Code>), and enable anonymous access or a
              matching auth proxy so the browser can load the dashboard.
            </Text>
          </Stack>
        </Alert>
      )}
    </Stack>
  );
}
